import { StackedBarChart, VerticalStackChart, YStack } from '@my/ui'
import { color, TZABrandGuidelines } from '@my/util'

const financialData = [
  {
    financialStrategy: 'Debt Management',
    priorities: {
      High: { text: 'Student Loans', amount: '5000' },
      Moderate: { text: 'Credit Card Debt', amount: '5000' },
      Low: { text: 'Auto Loans', amount: '100000' },
    },
  },
  {
    financialStrategy: 'Emergency Fund Establishment',
    priorities: {
      High: { text: 'Initial Emergency Fund Build', amount: '3000' },
      Moderate: { text: 'Expand Emergency Savings', amount: '6000' },
      Low: { text: 'Maintain Consistent Savings', amount: '500' },
    },
  },
  {
    financialStrategy: 'Goal-Based Savings',
    priorities: {
      High: { text: 'House Down Payment', amount: '18000' },
      Moderate: { text: 'Macbook Purchase', amount: '2100' },
      Low: { text: 'Road Bike Investment', amount: '3200' },
    },
  },
  {
    financialStrategy: 'Investment Education',
    priorities: {
      High: { text: 'Initial Investment Learning', amount: '5000' },
      Moderate: { text: 'Explore Low-Cost Index Funds', amount: '1000' },
      Low: { text: 'Retirement Planning Basics', amount: '500' },
    },
  },
]

const transformDataOld = (financialData: any) => {
  // Initialize empty arrays for the High, Moderate, and Low priorities
  const data1: { x: string; y: number; z: string }[] = [] // High priority data
  const data2: { x: string; y: number; z: string }[] = [] // Moderate priority data
  const data3: { x: string; y: number; z: string }[] = [] // Low priority data

  // Loop through each financial strategy and its priorities
  financialData?.forEach((strategy: any) => {
    // Extract the financial strategy name
    const strategyName = strategy.financialStrategy

    // Extract priorities and map them to the corresponding data arrays
    const { High, Moderate, Low } = strategy.priorities

    // Add High priority data
    if (High) {
      data1.push({
        x: strategyName, // Use the financial strategy name as the x value
        y: Number(High.amount), // Convert amount to number
        z: High?.text,
      })
    }

    // Add Moderate priority data
    if (Moderate) {
      data2.push({
        x: strategyName, // Use the financial strategy name as the x value
        y: Number(Moderate.amount), // Convert amount to number
        z: Moderate?.text,
      })
    }

    // Add Low priority data
    if (Low) {
      data3.push({
        x: strategyName, // Use the financial strategy name as the x value
        y: Number(Low.amount), // Convert amount to number
        z: Low?.text,
      })
    }
  })

  // Return the transformed data in the required format
  return { data1, data2, data3 }
}

const transformData = (data: typeof financialData) => {
  return Array.isArray(data)
  ? data.map((strategy) => Object.entries(strategy.priorities).map(([priority, {amount}]) => ({
    name: priority,
    value: Number(amount) || 0,
    group: priority,
    strategy: strategy.financialStrategy
  })))
  : []
};

const data1 = [
  { x: 'lorem1', y: 30 },
  { x: 'lorem2', y: 20 },
  { x: 'lorem3', y: 15 },
  { x: 'lorem4', y: 10 },
  { x: 'lorem5', y: 25 },
  { x: 'lorem6', y: 18 },
  { x: 'lorem7', y: 22 },
]

const data2 = [
  { x: 1, y: 10 },
  { x: 2, y: 5 },
  { x: 3, y: 5 },
  { x: 4, y: 2 },
  { x: 5, y: 10 },
  { x: 6, y: 8 },
  { x: 7, y: 15 },
]

const data3 = [
  { x: 1, y: 20 },
  { x: 2, y: 10 },
  { x: 3, y: 10 },
  { x: 4, y: 8 },
  { x: 5, y: 5 },
  { x: 6, y: 12 },
  { x: 7, y: 8 },
]
const RecommendationChartOld = (props: any) => {
  // Transform the financial data into the required format
  const { data1, data2, data3 } = transformDataOld(props?.priorityData ?? [])
  return (
    <StackedBarChart
      animate
      horizontal={false}
      data={[data1, data2, data3]}
      stackColorScale={[color.lightRed, color.tzaGreen, color.cyan]}
      legendData={[
        { name: 'High', fill: color.lightRed },
        { name: 'Medium', fill: color.cyan },
        { name: 'low', fill: color.tzaGreen },
      ]}
    />
  )
}

const RecommendationChart = (props: any) => {
  // Transform the financial data into the required format
  const chartData = transformData(props?.priorityData ?? []);
  const legendData = chartData.map((strategyData, idx) => ({ name: strategyData[0].strategy, fill: TZABrandGuidelines.chartColors[idx] }))
  return <VerticalStackChart 
    chartData={chartData} 
    chartZLabels={chartData.map((strategy) => strategy[0].strategy)}
    legendData={legendData}
  />
  return (
    <StackedBarChart
      animate
      horizontal={false}
      data={chartData}
      stackColorScale={TZABrandGuidelines.colorsArray.slice(1, chartData.length)}
      legendData={chartData.map((strategyData, idx) => ({ name: strategyData[0].z, fill: TZABrandGuidelines.colorsArray[idx+1] }))}
    />
  )
}

export default RecommendationChart
